import { httpClient } from "../../../../../utils/HttpClient";
import { ApiEndpoint } from "../../../../../utils/ApiEndpoint";
export const getRCSReportByPartners = async ({ token, data = {} }) => {
  const response = await httpClient(
    "post",
    ApiEndpoint + "reports/rcs/summary-by-partner",
    data,
    token,
  );

  return response.data;
};

export const getRCSPartners = async ({ token }) => {
  const response = await httpClient("get", ApiEndpoint + "partners", {}, token);

  return response.data;
};
